import React from 'react';
import { DraftFunction } from 'use-immer';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import classes from './styles.module.scss';

interface Props {
    value: string;
    formKey: string;
    label: string;
    update: (arg: Record<string, string> | DraftFunction<Record<string, string>>) => void;
}

export default function CircleCheckbox({ value, update, formKey, label }: Props) {
    return (
        <div className={`${classes.opt_in}`} id={`${formKey}_checkbox_id`}>
            <label htmlFor={formKey}>
                <div className={`${classes.custom_checkbox}`}>
                    <input
                        id={formKey}
                        type='checkbox'
                        checked={value === 'true'}
                        onChange={(e) => {
                            update((draft) => {
                                draft[formKey] = e.target.checked ? 'true' : 'false';
                                return draft;
                            });
                        }}
                    />
                    <div className={`${classes.icon_container}`}>
                        <FontAwesomeIcon icon='check' />
                    </div>
                </div>
                <span>{label}</span>
            </label>
        </div>
    );
}
